module.exports = __webpack_public_path__ + "img/foto7.0b1c728f.jpg";